<mat-toolbar class="toolbar-example">
    <span>{{ service.form.controls['id'].value?"Modify Candidate":"Add Candidate"}}</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<form [formGroup]="service.form" class="normal-form" (submit)='onSubmit()'>
    <mat-grid-list cols="2" rowHeight="320px">
        <mat-grid-tile>
            <div class="controles-container" style="margin-top:30px">
                <input type="hidden" formControlName="id">
                <!--Full Name Field-->
                <mat-form-field>
                    <input formControlName="candidateName" matInput type="text" placeholder="Candidate Name" required>
                    <mat-error *ngIf = "service.form.controls['candidateName'].errors?.required" >Name is required</mat-error>
                    <mat-error *ngIf = "service.form.controls['candidateName'].errors?.minlength" >Minimum 3 Charachters needed.</mat-error>
                    <mat-error *ngIf="service.form.controls['candidateName'].errors?.pattern">Please enter only characters</mat-error>

                </mat-form-field>

                <!--Email-Id Field-->
                <mat-form-field>
                    <input formControlName="email" matInput type="email" placeholder="Email Address" required>
                    <mat-error *ngIf="service.form.controls['email'].errors?.required">Email is required</mat-error>
                    <mat-error *ngIf="service.form.controls['email'].errors?.email">Please enter correct email format</mat-error>
                    <mat-icon
                      title="Eg. abc@domain.xy, abc@domain.xy.zp"
                      style="cursor: pointer; vertical-align: bottom; font-size: 20px; color: #252c61;"
                      matSuffix>
                      info
                    </mat-icon>
                </mat-form-field>

                <!--Contact No. Field-->
                <mat-form-field>
                    <input formControlName="contactNo" matInput type="number" placeholder="Contact No" required>
                    <mat-error *ngIf="service.form.controls['contactNo'].errors?.required">Contact No. is required</mat-error>
                    <mat-error *ngIf="service.form.controls['contactNo'].errors?.pattern">Maximum 10 digits are allowed</mat-error>
                </mat-form-field>
                
                <!--Address Field-->
                <mat-form-field>
                    <input formControlName="address" matInput placeholder="Address" required>
                    <mat-error *ngIf="service.form.controls['address'].errors?.required">Address is required</mat-error>
                </mat-form-field>

                <!--Date of Birth Field-->
                <mat-form-field>
                    <input formControlName="dob" matInput [matDatepicker]="picker" [max]="maxDate" placeholder="Date Of Birth" required>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <mat-error *ngIf="service.form.controls['dob'].errors?.required">Date of birth is required</mat-error>
                </mat-form-field>
            </div>
        </mat-grid-tile>

        <mat-grid-tile>
            <div class="controles-container">
                <!--Gender Field-->
                <div class="add-bottom-padding">
                    <mat-label>Gender: </mat-label>
                    <mat-radio-group formControlName="gender" (change)="genderChanged($event)">
                      <mat-radio-button value="MALE">MALE</mat-radio-button>
                      <mat-radio-button value="FEMALE">FEMALE</mat-radio-button>
                      <mat-radio-button value="OTHERS">OTHERS</mat-radio-button>

                      <!-- <mat-radio-button value="Other">Other</mat-radio-button> -->
                    </mat-radio-group>
                </div>

                <!--Total Mark Field-->                
                <mat-form-field>
                    <input type="number" formControlName="totalMarks" matInput placeholder="Total Marks">
                    <!-- <mat-error *ngIf="service.form.controls['totalMarks'].errors?.required">Please Enter Total Marks</mat-error> -->
                </mat-form-field>

                <!--Secured Mark/Score Field-->                
                <mat-form-field>
                    <input type="number" formControlName="score" matInput placeholder="Score"> <!-- [errorStateMatcher]="errorMatcher"-->
                    <!-- <mat-error *ngIf="service.form.controls['score'].errors?.scoreValidator">Score cannot be exceed than Full Marks</mat-error> -->
                    <!-- <mat-error *ngIf="service.form.controls['score'].errors?.required">Please Enter Your Score</mat-error> -->
                    <mat-error *ngIf="service.form.hasError('scoreValidator')">Score cannot be exceeded than Total Marks!</mat-error>
                </mat-form-field>

                <!--Attempt Status Field-->                
                <mat-form-field>
                    <mat-select formControlName = "attemptStatus" placeholder="Attempt Status" (change)="attemptStatusChanged($event)" required>
                        <mat-option value="DEFAULT">Default</mat-option>
                        <mat-option value="ATTEMPTED">Attempted</mat-option>  
                        <mat-option value="NOT ATTEMPTED">Not Attempted</mat-option>
                    </mat-select>
                    <mat-error *ngIf="service.form.controls['attemptStatus'].errors?.required">Please choose an attempt status</mat-error>
                </mat-form-field>
            </div>
        </mat-grid-tile>
    </mat-grid-list>
    <div class="button-row">
        <button mat-raised-button class="btn-color-example" type="submit" [disabled]="service.form.invalid">Submit</button>
        <button mat-raised-button class="btn-clear" (click)='onClear()'>Clear</button>
    </div>
</form>